import { useSheetContext } from "@/context/sheet";
import { useCreateAgency } from "@/hooks/agencies";
import { CreateAgency } from "@/models";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Form } from "./-form";

export const Route = createFileRoute("/(agencies)/agencies/_sheet/new")({
  component: RouteComponent,
});

function RouteComponent() {
  const { close } = useSheetContext();
  const navigate = useNavigate();
  const { mutateAsync } = useCreateAgency({
    onSuccess: (agency) => {
      close(() => {
        navigate({
          to: "/agencies",
          params: { id: agency.id.toString() },
        });
      });
    },
  });

  const create = async (agency: CreateAgency) => {
    await mutateAsync(agency);
  };

  return <Form onUpsert={create} />;
}
